import { Link } from 'react-router-dom';
import './Button.scss';

const Button = ({ to, fullWidth, blue, write, modal, ...rest }) => {
  const className = `Button ${fullWidth ? 'fullWidth' : ''} ${blue ? 'blue' : ''} ${write ? 'write' : ''}  ${modal ? 'modal' : ''}`;

  if (to) {
    return <Link to={to} className={className} {...rest} />;
  }

  return <button className={className} {...rest} />;
};

export default Button;
